module.exports = __webpack_public_path__ + "static/media/Sonia.cf2d24eb.jpeg";